import PersistentStorage from '../services/storage';

export class PersistentPaginationModel {
    constructor(storageKeyPrefix, defaultOptions = { itemsPerPage: 10 }) {
        if (!storageKeyPrefix || typeof storageKeyPrefix !== 'string') {
            throw new Error('"storageKeyPrefix" string parameter is required');
        }

        this.key = `${storageKeyPrefix}_items_per_page`;
        this.defaultOptions = defaultOptions;
    }

    getItemsPerPage() {
        const itemsPerPageFromStorage = PersistentStorage.getItem(this.key);

        return Number(itemsPerPageFromStorage) || this.defaultOptions.itemsPerPage;
    }

    setItemsPerPage(itemsPerPage) {
        PersistentStorage.setItem(this.key, itemsPerPage);
    }
}
